import { FormControl, List } from '@mui/material'
import { CheckListItem } from 'Components/CheckList/CheckListItem'
import { type SelectOption } from 'Components/SelectWithLabel'
import { useState } from 'react'
import { LabelWithToolTip } from 'Components/Label/Index'

type Props = {
  label?: string
  disabled?: boolean
  allOption?: boolean
  anyOption?: boolean // includes an Any option which unchecks all other options and returns -1 as the selected value
  items: Array<SelectOption<number>>
  selectedItems: Array<SelectOption<number>>
  fullWidth?: boolean
  flex?: boolean
  toolTip?: string
  dataTestId?: string
  setSelectedItems?: (arg: Array<SelectOption<number>>) => void
} & (
  | { otherOption?: false }
  | {
    otherOption: true
    otherValue: string
    setOtherValue: (arg: string) => void
  }
)
export function CheckList (props: Props): JSX.Element {
  const otherOption = props.otherOption ?? false
  let otherValue = ''
  if (props.otherOption === true) { otherValue = props.otherValue }
  const [
    otherItemEnabled,
    setOtherItemEnabled
  ] = useState(otherOption ? otherValue !== '' : false)

  function selectOption (value: SelectOption<number>): void {
    if (props.setSelectedItems == null) return
    if (!selectedItems.includes(value.id)) {
      props.setSelectedItems([
        ...props.selectedItems.filter((a) => a.id !== -1),
        value
      ])
    } else {
      const newArray = props.selectedItems.filter((a) => a.id !== value.id)
      props.setSelectedItems([...newArray])
    }
  }
  function toggleAll (): void {
    const selectAll = props.selectedItems?.length !== props.items.length
    if (props.setSelectedItems == null) return
    if (selectAll) props.setSelectedItems(props.items)
    else props.setSelectedItems([])
  }

  function toggleAny (): void {
    if (props.setSelectedItems != null) {
      props.setSelectedItems([{ id: -1, name: 'Any' }])
    }
  }

  const selectedItems = props.selectedItems?.map((i) => i.id)
  const flex = props.flex ?? false
  const allOption = props.allOption ?? false
  let setOtherValue = (arg: string): void => { }
  if (props.otherOption === true) {
    setOtherValue = props.setOtherValue
  }
  return (
    <FormControl variant="filled" fullWidth={props.fullWidth} sx={{ mt: 1 }}>
      <LabelWithToolTip
        isInline={false}
        required={false}
        name={''}
        labelText={props.label ?? ''}
        toolTipText={props.toolTip}
      />

      <List
        sx={{
          width: '100%',
          maxWidth: '100%',
          bgcolor: 'transparent',
          display: flex ? 'inline-flex' : 'block',
          flexWrap: flex ? 'wrap' : 'nowrap'
        }}
      >
        {(props.anyOption ?? false) && (
          <CheckListItem
            edge="start"
            key={'Any'}
            flex={props.flex}
            disabled={props.disabled}
            name="Any"
            checked={props.selectedItems.filter((a) => a.id === -1).length === 1}
            onClick={toggleAny}
            text="Any"
            dataTestId={props.dataTestId === undefined ? undefined : `${props.dataTestId}Any`}
          />
        )}
        {allOption && (
          <CheckListItem
            edge="start"
            key={'All'}
            flex={props.flex}
            disabled={props.disabled}
            name="All"
            checked={props.selectedItems?.length === props.items.length}
            onClick={toggleAll}
            text="All"
            dataTestId={props.dataTestId === undefined ? undefined : `${props.dataTestId}All`}
          />
        )}
        {props.items?.map((value) => (
          <CheckListItem
            edge="start"
            key={value.name}
            flex={props.flex}
            disabled={props.disabled}
            name={`checkbox-list-label-${value.name}`}
            onClick={() => { selectOption(value) }}
            checked={selectedItems.includes(value.id) ?? ''}
            text={value.name}
            dataTestId={props.dataTestId === undefined ? undefined : `${props.dataTestId}${value.id}`}
          />
        ))}

        {otherOption && (
          <CheckListItem
            key={'Other'}
            edge="start"
            flex={props.flex}
            disabled={props.disabled}
            name="Other"
            checked={otherItemEnabled}
            onClick={() => { setOtherItemEnabled(!otherItemEnabled) }}
            text="Other"
            hasTextArea={true}
            textAreaValue={otherValue}
            setTextAreaValue={setOtherValue}
          />
        )}
      </List>
    </FormControl>
  )
}
